import React from 'react';
import TagPage from '../../components/TagPage';

const TagPageClient = (props) => <TagPage {...props} />;

export default TagPageClient;
